<template>
  <div>
    <span v-for="(tag, index) in tagProperties.unchanged" :key="`unchanged-${index}`"
          class="kt-font-info">
      <i class="fa fa-minus" />{{ tag }}<br>
    </span>

    <span v-for="(tag, index) in tagProperties.added" :key="`added-${index}`"
          class="kt-font-success">
      <i class="fa fa-plus-circle" />{{ tag }}<br>
    </span>

    <span v-for="(tag, index) in tagProperties.removed" :key="`removed-${index}`"
          class="kt-font-danger">
      <i class="fa fa-minus-circle" />{{ tag }}<br>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    tagProperties: {
      type: Object,
      required: true,
    },
  },
};
</script>
